import { c as _c } from "react/compiler-runtime";
import { TextSkeleton } from '@/frontend/design-system/atoms/TextSkeleton';
import { LightCard } from '@/frontend/design-system/data-display/Card';
import { MarginsLayout } from '@/frontend/design-system/layouts/MarginsLayout';
export function LoadingSkeleton() {
  const $ = _c(2);
  let t0;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = <LightCard className="flex w-142 flex-col gap-2"><section className="grid grid-cols-[50px_1fr_50px] gap-2"><TextSkeleton dark={true} /><TextSkeleton dark={true} /><TextSkeleton dark={true} /></section><TextSkeleton height={20} dark={true} /><TextSkeleton height={220} dark={true} /></LightCard>;
    $[0] = t0;
  } else {
    t0 = $[0];
  }
  let t1;
  if ($[1] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = <MarginsLayout><div className="flex flex-col gap-8 lg:flex-row">{t0}<div className="w-full space-y-6"><section className="flex justify-between"><TextSkeleton width={400} /><TextSkeleton width={100} height={20} /></section>{Array.from({
            length: 2
          }).map(_temp)}</div></div></MarginsLayout>;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  return t1;
}
function _temp(_, idx) {
  return <LightCard key={idx} className="flex flex-col gap-2"><TextSkeleton width={300} dark={true} /><TextSkeleton height={12} width={500} dark={true} /><TextSkeleton height={20} count={3} dark={true} /></LightCard>;
}